import script from "./DepartmentAboutTab.vue?vue&type=script&setup=true&lang=js"
export * from "./DepartmentAboutTab.vue?vue&type=script&setup=true&lang=js"

import "./DepartmentAboutTab.vue?vue&type=style&index=0&id=07e29f0f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07e29f0f"]])

export default __exports__